var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small-modal',{staticClass:"integration-modal",attrs:{"fit-content":true,"title":_vm.modalTitle},on:{"close":_vm.close}},[_c('div',{staticClass:"integration-steps-modal"},[(_vm.toolChosen === 'google')?_c('google-sheet'):(_vm.toolChosen === 'klaviyo')?_c('klaviyo'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }